import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=20909f1c&scoped=true"
import script from "./infoDetail.vue?vue&type=script&lang=js"
export * from "./infoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20909f1c",
  null
  
)

export default component.exports